/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bahesu3%7Bjustify-content%3Aflex-end%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0qpxbi%7Bpadding-top%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2hwx1wug%7Bmargin-right%3Aauto%7D");
import { memo, type MemoExoticComponent } from 'react';
import { defineMessages, type MessageDescriptor, useIntl } from 'react-intl';
import { ButtonGroup } from '@atlaskit/button';
import Button from '@atlaskit/button/new';
import EditorAddIcon from '@atlaskit/icon/core/add';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { type LinkPickerPluginAction, type LinkPickerState, type LinkSearchListItemData } from '../../../common/types';
import { UnauthenticatedError } from '../../../common/utils/errors';
import { LinkPickerSubmitButton } from './link-picker-submit-button';
const formFooterStyles = null;
const formFooterActionStyles = null;
export const messages: {
  cancelButton: {
    id: string;
    defaultMessage: string;
    description: string;
  };
  submittingStatusMessage: {
    id: string;
    defaultMessage: string;
    description: string;
  };
} = defineMessages({
  cancelButton: {
    id: 'fabric.linkPicker.button.cancel',
    defaultMessage: 'Cancel',
    description: 'Button to cancel and dismiss the link picker'
  },
  submittingStatusMessage: {
    id: 'fabric.linkPicker.status.submitting',
    defaultMessage: 'Submitting',
    description: 'Accessibility text to indicate the form has been submitted, and submission is in-progress'
  }
});
export const testIds = ({
  insertButton: 'link-picker-insert-button',
  cancelButton: 'link-picker-cancel-button',
  actionButton: 'link-picker-action-button',
  submitStatusA11yIndicator: 'link-picker-submit-status-a11y-indicator'
} as const);
interface FormFooterProps extends React.HTMLAttributes<HTMLElement> {
  /** If the results section appears to be loading, impact whether the submit button is disabled */
  isLoading: boolean;
  /** Controls showing a "submission in-progres" UX */
  isSubmitting?: boolean;
  error: unknown | null;
  url: string;
  queryState: LinkPickerState | null;
  items: LinkSearchListItemData[] | null;
  isEditing?: boolean;
  onCancel?: () => void;
  action?: LinkPickerPluginAction;
  customSubmitButtonLabel?: MessageDescriptor;
  submitMessageId?: string;
  hideSubmitButton?: boolean;
  disableManualUrlInsert?: boolean;
}
export const FormFooter: MemoExoticComponent<({
  isLoading,
  isSubmitting,
  error,
  url,
  queryState,
  items,
  isEditing,
  onCancel,
  action,
  customSubmitButtonLabel,
  submitMessageId,
  hideSubmitButton,
  disableManualUrlInsert,
  className,
  ...restProps
}: FormFooterProps) => JSX.Element | null> = memo(({
  isLoading,
  isSubmitting = false,
  error,
  url,
  queryState,
  items,
  isEditing,
  onCancel,
  action,
  customSubmitButtonLabel,
  submitMessageId,
  hideSubmitButton,
  disableManualUrlInsert,
  className,
  ...restProps
}: FormFooterProps): JSX.Element | null => {
  const intl = useIntl();
  if (error && error instanceof UnauthenticatedError) {
    return null;
  }
  const createButton = (pluginAction: LinkPickerPluginAction) => <Button testId={testIds.actionButton} onClick={pluginAction.callback} appearance="default" iconBefore={() => <EditorAddIcon label="" color="currentColor" size="small" />} isDisabled={isSubmitting} aria-labelledby={isSubmitting ? submitMessageId : undefined}>
				{typeof pluginAction.label === 'string' ? pluginAction.label : intl.formatMessage(pluginAction.label)}
			</Button>;
  return <footer
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
  className={ax(["_1e0c1txw _1bahesu3 _ca0qpxbi", className])} {...restProps}>
				{isSubmitting && <VisuallyHidden role="status" id={submitMessageId} testId={testIds.submitStatusA11yIndicator}>
						{intl.formatMessage(messages.submittingStatusMessage)}
					</VisuallyHidden>}
				{action && <div className={ax(["_2hwx1wug"])}>{createButton(action)}</div>}
				<ButtonGroup>
					{onCancel && <Button appearance="subtle" onClick={onCancel} testId={testIds.cancelButton} isDisabled={isSubmitting} aria-labelledby={isSubmitting ? submitMessageId : undefined}>
							{intl.formatMessage(messages.cancelButton)}
						</Button>}

					{!hideSubmitButton && <LinkPickerSubmitButton isEditing={isEditing} isLoading={isLoading} isSubmitting={isSubmitting} customSubmitButtonLabel={customSubmitButtonLabel} error={error} items={items} queryState={queryState} submitMessageId={submitMessageId} testId={testIds.insertButton} url={url} disableManualUrlInsert={disableManualUrlInsert} />}
				</ButtonGroup>
			</footer>;
});